import { toSentenceCase } from '@noths/polaris-client-utils';

import * as copy from 'src/components/organisms/FilterMenu/constants/copy';
import type { ActiveSortOption } from 'src/components/organisms/FilterMenu/types';

interface SlimFilterMenuLabels {
  accessibleFilterLabel: string;
  accessibleResetAllLabel: string;
  accessibleSortLabel: string;
  filterAndSortLabel: string;
  filterLabel: string;
  resetAllLabel: string;
}

export const getSlimFilterMenuLabels = (
  totalNumberOfActiveOptions: number,
  activeSortOption: ActiveSortOption,
): SlimFilterMenuLabels => {
  const resetAllLabel = copy.RESET_ALL;
  const filterLabel = copy.FILTER_CTA;
  const accessibleResetAllLabel = `Reset all filters`;
  const accessibleFilterLabel = `${copy.FILTER_CTA} options (${totalNumberOfActiveOptions} selected)`;
  const filterAndSortLabel = copy.FILTER_AND_SORT_CTA;
  const accessibleSortLabel = `${copy.SORT_BY}${
    activeSortOption ? ` (${toSentenceCase(activeSortOption.title)} selected)` : ''
  }`;

  return {
    filterLabel,
    filterAndSortLabel,
    accessibleFilterLabel,
    accessibleSortLabel,
    resetAllLabel,
    accessibleResetAllLabel,
  };
};
